import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { ReOrderDotsVerticalRegular } from "@fluentui/react-icons";

interface PortalItemProps {
  item: {
    id: string;
    content: string;
  };
}

function PortalItem({ item }: PortalItemProps) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: item.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div className="flex bg-white" ref={setNodeRef} style={style}>
      <div className="p-4" {...attributes} {...listeners}>
        <ReOrderDotsVerticalRegular fontSize={20} />
      </div>
      <div className="mx-6 my-4 font-medium text-cool-gray-600">
        {item.content}
      </div>
    </div>
  );
}

export default PortalItem;
